/*!
 * Veltari mobile navigation
 * Drill-down panels for the drawer rendered by snippets/header-menu-drawer.liquid.
 * The theme (mega-menu.js) still opens and closes the drawer itself; this file only drives the panels inside it.
 */
(function () {
  'use strict';

  var drawer = document.getElementById('m-menu-drawer');
  var nav = drawer ? drawer.querySelector('[data-vnav]') : null;
  if (!drawer || !nav || nav.getAttribute('data-vnav-ready') === 'true') { return; }
  nav.setAttribute('data-vnav-ready', 'true');

  var panels = Array.prototype.slice.call(nav.querySelectorAll('[data-vnav-panel]'));
  if (!panels.length) { return; }

  var rootPanel = panels[0];
  var stack = [rootPanel.id];
  var openers = [];
  var resetTimer = null;

  function byId(id) { return document.getElementById(id); }

  /* Mark every panel as the current one, one that is stacked behind it, or one that is still ahead. */
  function paint() {
    var currentId = stack[stack.length - 1];
    panels.forEach(function (panel) {
      var state = panel.id === currentId ? 'active' : (stack.indexOf(panel.id) > -1 ? 'behind' : 'ahead');
      panel.setAttribute('data-state', state);
      if (state === 'active') {
        panel.removeAttribute('inert');
        panel.removeAttribute('aria-hidden');
      } else {
        panel.setAttribute('inert', '');
        panel.setAttribute('aria-hidden', 'true');
      }
    });
    nav.setAttribute('data-vnav-depth', String(stack.length - 1));
  }

  function focusSoon(el) {
    if (!el) { return; }
    window.requestAnimationFrame(function () {
      try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
    });
  }

  function openPanel(id, opener) {
    var target = byId(id);
    if (!target || stack[stack.length - 1] === id) { return; }
    stack.push(id);
    openers.push(opener || null);
    target.scrollTop = 0;
    paint();
    focusSoon(target.querySelector('[data-vnav-back]'));
  }

  function closePanel() {
    if (stack.length < 2) { return false; }
    stack.pop();
    var opener = openers.pop();
    paint();
    focusSoon(opener);
    return true;
  }

  function resetNow() {
    if (stack.length < 2) { return; }
    nav.classList.add('vnav--instant');
    stack = [rootPanel.id];
    openers = [];
    paint();
    void nav.offsetWidth; /* flush styles so the reset does not animate */
    nav.classList.remove('vnav--instant');
  }

  function toggleDrawer() {
    var burger = document.querySelector('.m-hamburger-box');
    if (burger) { burger.click(); }
  }

  nav.addEventListener('click', function (event) {
    var go = event.target.closest('[data-vnav-go]');
    if (go) {
      event.preventDefault();
      openPanel(go.getAttribute('data-vnav-go'), go);
      return;
    }
    if (event.target.closest('[data-vnav-back]')) {
      event.preventDefault();
      closePanel();
    }
  });

  /* Escape steps back one level, then closes the drawer. */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' && event.key !== 'Esc') { return; }
    if (!drawer.classList.contains('open')) { return; }
    event.preventDefault();
    if (!closePanel()) { toggleDrawer(); }
  });

  /* Swipe right to go back one level. */
  var startX = 0;
  var startY = 0;
  var tracking = false;
  nav.addEventListener('touchstart', function (event) {
    if (stack.length < 2 || event.touches.length !== 1) { tracking = false; return; }
    startX = event.touches[0].clientX;
    startY = event.touches[0].clientY;
    tracking = true;
  }, { passive: true });
  nav.addEventListener('touchend', function (event) {
    if (!tracking) { return; }
    tracking = false;
    var touch = event.changedTouches[0];
    var dx = touch.clientX - startX;
    var dy = Math.abs(touch.clientY - startY);
    if (dx > 80 && dy < 45) { closePanel(); }
  }, { passive: true });

  /* Reopen on the first level every time the drawer is closed. */
  if (typeof window.MutationObserver === 'function') {
    new window.MutationObserver(function () {
      window.clearTimeout(resetTimer);
      if (!drawer.classList.contains('open')) {
        resetTimer = window.setTimeout(resetNow, 700);
      }
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  /* The back/forward cache can restore a page with the drawer still open. */
  window.addEventListener('pageshow', function (event) {
    if (event.persisted && drawer.classList.contains('open')) { toggleDrawer(); }
  });

  paint();
})();
